import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './TermsAndConditionsPage.css';

const TermsAndConditionsPage = () => {
  useEffect(() => {
    document.title = 'Términos y condiciones | Always Aligners';
  }, []);

  return (
    <div className="terms-page">
      <div className="container terms-page__inner">
        <header className="terms-page__header">
          <p className="terms-page__eyebrow">Información legal</p>
          <h1 className="terms-page__title">Términos y condiciones de uso</h1>
          <p className="terms-page__meta">
            Última actualización: marzo de 2026. Al utilizar la plataforma Always Aligners aceptás estos
            términos en su totalidad.
          </p>
        </header>

        <div className="terms-page__content">
          <section className="terms-page__section" aria-labelledby="terms-s1">
            <h2 id="terms-s1">1. Objeto y aceptación</h2>
            <p>
              Los presentes términos regulan el acceso y uso del sitio web, la aplicación y los servicios
              digitales de <strong>Always Aligners</strong> (en adelante, la &quot;Plataforma&quot;),
              destinados a <strong>profesionales de la salud odontológica</strong> y personas que deseen
              acceder a formación, información sobre el sistema clínico de alineadores y, cuando
              corresponda, adquirir productos o servicios ofrecidos en línea.
            </p>
            <p>
              El uso de la Plataforma implica la lectura y aceptación sin reservas de estos términos. Si
              no estás de acuerdo, debés abstenerte de utilizar los servicios.
            </p>
          </section>

          <section className="terms-page__section" aria-labelledby="terms-s2">
            <h2 id="terms-s2">2. Descripción de los servicios</h2>
            <p>
              La Plataforma puede incluir, entre otros: contenidos sobre el sistema Always Aligners;
              <strong> cursos y formación en línea o presencial</strong>; publicación de novedades;
              posibilidad de <strong>registro de usuario</strong>;{' '}
              <strong>comercialización de cursos, asesorías, eventos y productos</strong> según lo
              disponible en cada momento; y herramientas de gestión de compras y acceso a contenidos
              adquiridos.
            </p>
            <p>
              Las características concretas (disponibilidad geográfica, modalidad, requisitos de acceso,
              certificaciones, etc.) se informan en cada oferta o en la descripción del producto o
              servicio.
            </p>
          </section>

          <section className="terms-page__section" aria-labelledby="terms-s3">
            <h2 id="terms-s3">3. Registro y cuenta de usuario</h2>
            <p>
              Para determinadas funciones podrá ser necesario crear una cuenta proporcionando datos
              veraces y actualizados. Sos responsable de la confidencialidad de tus credenciales y de
              las actividades realizadas desde tu cuenta.
            </p>
            <p>
              Cuando tengas sesión iniciada podés cambiar tu contraseña desde la opción correspondiente
              en tu cuenta, debiendo indicar la contraseña actual por motivos de seguridad. También
              podés usar el flujo de recuperación de contraseña si olvidaste el acceso.
            </p>
            <p>
              Podemos suspender o cancelar cuentas ante incumplimientos de estos términos, uso fraudulento
              o riesgo para la seguridad de la Plataforma o de terceros.
            </p>
          </section>

          <section className="terms-page__section" aria-labelledby="terms-s4">
            <h2 id="terms-s4">4. Uso permitido</h2>
            <p>
              Te comprometés a utilizar la Plataforma de conformidad con la ley, la buena fe y estos
              términos. Queda prohibido: vulnerar sistemas o medidas de seguridad; extraer datos de forma
              masiva no autorizada; suplantar identidades; difundir malware; o utilizar los contenidos
              para fines ilícitos o que lesionen derechos de terceros.
            </p>
          </section>

          <section className="terms-page__section" aria-labelledby="terms-s5">
            <h2 id="terms-s5">5. Propiedad intelectual</h2>
            <p>
              Los textos, imágenes, videos, marcas, logotipos, diseños, materiales de cursos y demás
              contenidos de la Plataforma están protegidos por la legislación aplicable. Salvo indicación
              expresa, no se concede licencia para copiarlos, distribuirlos o explotarlos comercialmente
              fuera de lo permitido por el uso normal del servicio o por la licencia asociada a un
              producto adquirido.
            </p>
          </section>

          <section className="terms-page__section" aria-labelledby="terms-s6">
            <h2 id="terms-s6">6. Compras, precios y pagos</h2>
            <p>
              Las ofertas, precios, medios de pago, impuestos aplicables y políticas de cancelación o
              reembolso —cuando existan— se detallan en el proceso de compra o en las condiciones
              particulares de cada producto. El contrato de compra se perfecciona según lo indicado al
              confirmar el pedido y abonar cuando corresponda.
            </p>
          </section>

          <section className="terms-page__section" aria-labelledby="terms-s7">
            <h2 id="terms-s7">7. Contenido formativo y responsabilidad profesional</h2>
            <p>
              Los cursos, materiales y comunicaciones sobre el sistema Always Aligners tienen carácter
              <strong> formativo y de actualización profesional</strong>. No sustituyen el juicio clínico
              del profesional ni la relación directa con el paciente.
            </p>
            <p>
              Cada odontólogo es responsable de evaluar la idoneidad de los tratamientos según su
              formación, la normativa vigente y las particularidades de cada caso. Always Aligners no
              presta servicios de diagnóstico ni tratamiento directo al paciente final a través de esta
              Plataforma.
            </p>
            <h3 className="terms-page__subheading">Certificados digitales de finalización de curso</h3>
            <p>
              La Plataforma puede emitir <strong>certificados digitales de finalización</strong> cuando el
              usuario cumpla los criterios definidos para cada curso (por ejemplo, completar el contenido
              y/o aprobar las evaluaciones previstas, según corresponda a cada oferta). Esos documentos
              tienen carácter de <strong>constancia de cumplimiento</strong> del programa de formación
              accedido a través de la Plataforma.
            </p>
            <p>
              No constituyen por sí mismos <strong>títulos oficiales</strong> ni habilitaciones
              profesionales, salvo que una oferta o la normativa aplicable lo indique expresamente. Son
              <strong> personales e intransferibles</strong>, asociados a la cuenta con la que se realizó
              el curso. El diseño o el soporte (visualización, impresión o archivo) puede actualizarse;
              la referencia válida es el registro de cumplimiento en la Plataforma.
            </p>
          </section>

          <section className="terms-page__section" aria-labelledby="terms-s8">
            <h2 id="terms-s8">8. Limitación de responsabilidad</h2>
            <p>
              En la medida máxima permitida por la ley, la Plataforma se ofrece &quot;tal cual&quot;
              disponible. No garantizamos la inexistencia de interrupciones o errores, aunque
              procuramos mantener el servicio de forma razonable.
            </p>
            <p>
              No seremos responsables por daños indirectos, lucro cesante o pérdida de datos salvo que la
              ley imperativa disponga lo contrario.
            </p>
          </section>

          <section className="terms-page__section" aria-labelledby="terms-s9">
            <h2 id="terms-s9">9. Enlaces y servicios de terceros</h2>
            <p>
              La Plataforma puede incluir enlaces a sitios o servicios de terceros (pasarelas de pago,
              redes sociales, etc.). No controlamos esos sitios; su uso se rige por sus propios términos y
              políticas.
            </p>
          </section>

          <section className="terms-page__section" aria-labelledby="terms-s10">
            <h2 id="terms-s10">10. Modificaciones</h2>
            <p>
              Podemos actualizar estos términos. Publicaremos la versión vigente en esta página e
              indicaremos la fecha de actualización. El uso continuado de la Plataforma tras los cambios
              puede implicar la aceptación de los mismos, salvo que la ley exija otro procedimiento.
            </p>
          </section>

          <section className="terms-page__section" aria-labelledby="terms-s11">
            <h2 id="terms-s11">11. Ley aplicable y jurisdicción</h2>
            <p>
              Estos términos se interpretan según las leyes de la <strong>República Argentina</strong>.
              Para cualquier controversia, las partes se someten a los tribunales ordinarios con
              competencia en la <strong>Ciudad Autónoma de Buenos Aires</strong>, salvo normas
              imperativas en contrario.
            </p>
          </section>

          <section className="terms-page__section" aria-labelledby="terms-s12">
            <h2 id="terms-s12">12. Contacto</h2>
            <p>
              Para consultas sobre estos términos podés utilizar los canales de contacto que Always
              Aligners habilite en el sitio o en la Plataforma.
            </p>
          </section>
        </div>

        <footer className="terms-page__footer">
          <Link to="/" className="btn btn--secondary terms-page__back">
            Volver al inicio
          </Link>
        </footer>
      </div>
    </div>
  );
};

export default TermsAndConditionsPage;
